import React from 'react';
import { Divider, ListItemButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ToolbarActions } from '@/core';
import { getAppendix } from '@/core/helpers/getAppendix.ts';

import { styles } from './styles.ts';

export const TableActions = ({
  selectedRows,
  onDelete,
  onDeactivate,
  onActivate,
  onDuplicate,
  onCancel,
  actions,
  isDuplicateDisabled,
}: {
  selectedRows: number;
  onDelete: () => void;
  onDuplicate: () => void;
  onDeactivate: () => void;
  onActivate: () => void;
  onCancel: () => void;
  actions: ToolbarActions;
  isDuplicateDisabled?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ width: '100%', paddingBottom: '10px' }}
    >
      <Stack direction="row" justifyContent="center" alignItems="center" gap={10}>
        <Typography fontSize={14} fontWeight={500}>
          {getAppendix({ count: selectedRows, translator: t, onlyCount: true })}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="center" alignItems="center">
        {actions.onDelete && (
          <ListItemButton onClick={onDelete} sx={styles.listItem}>
            {t('ACTIONS.DELETE')}
          </ListItemButton>
        )}
        {actions.onActivate && (
          <ListItemButton sx={styles.listItem} onClick={onActivate}>
            {t('ACTIONS.ACTIVATE')}
          </ListItemButton>
        )}
        {actions.onDeactivate && (
          <ListItemButton sx={styles.listItem} onClick={onDeactivate}>
            {t('ACTIONS.DEACTIVATE')}
          </ListItemButton>
        )}
        {actions.onDuplicate && (
          <ListItemButton sx={styles.listItem} onClick={onDuplicate} disabled={isDuplicateDisabled}>
            {t('ACTIONS.DUPLICATE')}
          </ListItemButton>
        )}
        <Divider orientation="vertical" sx={styles.divider} />
        <ListItemButton sx={styles.listItem} onClick={onCancel}>
          {t('ACTIONS.CANCEL')}
        </ListItemButton>
      </Stack>
    </Stack>
  );
};
